import { Validator } from 'vee-validate';

import { i18n } from '../../translation.js';
import './file-upload.scss';
import template from './file-upload.vhtml';

export default {
	inject: [ '$validator' ],
	template,
	props: {
		multiple: {
			type: Boolean,
			default: false,
		},
		truncatLength: {
			type: Number,
			default: 8,
		},
		inputLabel: {
			type: String,
			default: '',
		},
		inputName: {
			type: String,
			default: 'files[]',
		},
		vvAs: {
			type: String,
			default: '',
		},
		inputClass: {
			type: String,
			default: '',
		},
		customValidateString: {
			type: String,
			default: "''",
		},
	},
	computed: {
		message() {
			const fileName = this.files.length > 0 ? this.truncateName( this.files[0].name, this.truncatLength ) : '';
			if ( this.multiple && this.files.length > 0 && !this.errors.has( this.inputName ) ) {
				return this.files.length > 1 ? i18n.t( 'xFiles', { count: this.files.length }) : fileName;
			} else {
				return this.files.length > 0 && !this.errors.has( this.inputName ) ? fileName : this.label;
			}
		},
	},
	data() {
		return {
			files: [],
			label: this.multiple ? i18n.t( 'chooseFiles' ) : i18n.t( 'chooseFile' ), 
		};
	},
	methods: {
		processFiles( $event ) {
			this.files = $event.target.files;
		},
		truncateName( str, length ) {
			const lastIndex = str.lastIndexOf( '.' );
			return lastIndex - 2 > length ? str.substring( 0, length ) + '...' + str.substring( lastIndex - 2 ) : str;
		},
	},
	created() {
		const dictionary = {
			en: {
				messages: {
					ext: () => 'The files is not supported, upload: doc, docx, pdf, rtf, txt, jpg, jpeg or png',
				},
			},
			da: {
				messages: {
					ext: () => 'Filen er ikke understøttet, upload: doc, docx, pdf, rtf,txt ,jpg, jpeg eller png',
				},
			},
		};

		Validator.updateDictionary( dictionary );
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/file-upload/file-upload.js